import {BaseModuleState} from "../../../infrastructure/models/base-module-state";
import {computed} from "mobx";
import {BaseMobxState} from "../../../infrastructure/mobx/base-mobx-state";
import {AppStore} from "../../../core/app/app-store";
import {LoggerUtils} from "../../../infrastructure/utils/logger/logger-utils";
import {DatetimeUtils} from "../../../infrastructure/utils/datetime-utils";
import {DeviceViewModel} from "../../../core/models/device.view-model";
import {TermsUtils} from "../../../infrastructure/utils/terms-utils";
import {NavigationManager} from "../../../core/managers/navigation-manager";
import {FilterBarModuleConfig} from "../filter-bar-module.config";
import {singleton} from "../../../infrastructure/decorators/singleton";
import {FILTER_BAR_MODULE} from "../filter-bar-module.consts";
import {FilterBarModuleSortModel} from "./filter-bar-module.sort-model";

@singleton
export class FilterBarModuleState extends BaseModuleState {
  static injectables = [...BaseMobxState.injectables, NavigationManager, AppStore, LoggerUtils, DatetimeUtils, DeviceViewModel, TermsUtils, FilterBarModuleConfig];

  @computed get userCountryId() {
    return this.appState.locale?.userCountryId;
  }

  @computed get showOddsButton(): Number {
    return this.appState.topBookmaker?.id > 0;
  }

  @computed get showOdds(): Boolean {
    return this.appState.showOdds;
  }

  @computed get filters(): Array<FilterBarModuleSortModel>  {
    const filters: Array<FilterBarModuleSortModel> = FILTER_BAR_MODULE.FILTERS.map(filter => new FilterBarModuleSortModel(filter));

    return filters
  }
}
